export const SEND_EMAIL = "SEND_EMAIL";
export const SEND_EMAIL_SUCCESSFUL = "SEND_EMAIL_SUCCESSFUL";
export const SEND_EMAIL_FAILED = "SEND_EMAIL_FAILED";


export const VERIFY_EMAIL_OTP = "VERIFY_EMAIL_OTP";
export const VERIFY_EMAIL_OTP_SUCCESSFUL = "VERIFY_EMAIL_OTP_SUCCESSFUL";
export const VERIFY_EMAIL_OTP_FAILED = "VERIFY_EMAIL_OTP_FAILED";



// TO RESET ALL ERRORS

export const RESET_VERIFY_EMAILOTP_ERRORS = "RESET_VERIF_EMAILYOTP_ERRORS"

export const UPDATE_NEW_EMAIL = "UPDATE_NEW_EMAIL"
export const UPDATE_NEW_EMAIL_SUCCESS = "UPDATE_NEW_EMAIL_SUCCESS"
export const UPDATE_NEW_EMAIL_FAILED = "UPDATE_NEW_EMAIL_FAILED"